import { useQuery } from "react-query";
import { AppConstant, KeyConstant } from "@/const";
import { PaginationType } from "@/types/common";
import { ShipService } from "@/services";
import dayjs from "dayjs";

export type ShipSearchFilterValue = {
  licensePlate?: string;
  start?: Date | null;
  end?: Date | null;
};

export type ShipSearchPayloadType = {
  paginationParam: Partial<PaginationType>;
  filterParam: ShipSearchFilterValue;
};

const useShipSearchList = (props: ShipSearchPayloadType) => {
  const { paginationParam, filterParam } = props;
  const { page, size } = paginationParam || {};
  const { licensePlate, start, end } = filterParam || {};

  const { data, isLoading, isError, refetch } = useQuery({
    queryKey: [KeyConstant.REACT_QUERY.getPersonList, page, size, filterParam],
    queryFn: () => {
      return ShipService.getShipList({
        page: page || 1,
        size: size || AppConstant.DEFAULT_SIZE_PAGE,
        license_plate: licensePlate,
        start_time: start ? dayjs(start)?.valueOf() : undefined,
        end_time: end ? dayjs(end)?.valueOf() : undefined,
        is_get_people_in_ship: 1,
        state: 1,
      });
    },
  });

  const { data: requestList, ...pagination } = data || {};

  return {
    requestList: requestList || [],
    pagination: (pagination as PaginationType) || {},
    isLoading,
    isError,
    refetch,
  };
};

export default useShipSearchList;
